const ListaPagos = () => import("@/app/views/pagos/views/ListaPagos");
const DetallePago = () => import("@/app/views/pagos/views/DetallePago");

const paymentRoutes = [
  {
    path: "pagos",
    redirect: "/gestion/pagos",
    name: "Pagos",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Listado",
        component: ListaPagos,
        meta: {
          auth: true
        }
      },
      {
        path: "/gestion/pagos",
        name: '',
        component: DetallePago,
        meta: {
          auth: true
        },
        children: [
          {
            path: '/gestion/pagos/:id',
            name: 'Detalle',
            meta: {
              auth: true
            }
          }
        ]
      },
    ]

  },
];

export default paymentRoutes;

